import React from "react"
import { FaPlus } from "react-icons/fa"
import { type Props } from "./_types"
const IconPlus: React.FC<Props> = ({ size = 15, color = "#fff" }): React.ReactElement => {
  return <FaPlus size={size} color={color} />
}

export default IconPlus
